export default `#define Q(p) p*=rotate2D(round(atan(p.y,p.x)/a)*a),
float de(vec3 p){
  float a=PI/8.0;
  for(int i=0;i++<3;)
    Q(p.yx)p.y-=.8,
    Q(p.zy)p.z-=.8;
  return .5*abs(length(vec2(length(p.xy)-.1,p.z))-.1)+1e-3;
}`